export const routes = {
  accounting: {
    home: '/accounting',
    subscriptionEstimates: '/subscription-estimates',
    csvUpload: '/csv-uploader',
  },
};
